<template>
  <div id="clientInfo">
    <a-form
      ref="stepClientInfoRef"
      class="ant-round-form material-other-info-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >

      <!--客户来源 select options -->
      <a-form-item name="sourceOfCust" :label="$t('pages_merchant2_034')" :rules="{ required: true }">
        <a-select v-model:value="modelForm.sourceOfCust" class="input-primary" :placeholder="$t('pages_merchant2_034')" allow-clear mode="multiple">
          <a-select-option v-for="item in clientSourceOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.sourceOfCustDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.sourceOfCustMessage }}</span>
        </div>
      </a-form-item>

      <!-- 客户所在国家地区，多选 select-->
      <a-form-item name="countryOfCust" :label="$t('pages_merchant2_035')" :rules="{ required: true }">
        <div class="explain">{{ $t('pages_merchant2_036_0') }}</div>
        <a-select
          v-model:value="modelForm.countryOfCust"
          class="input-primary"
          :placeholder="$t('pages_merchant2_035')"
          mode="multiple"
          allow-clear
          :max-tag-count="5"
          @change="handleCountryChange"
        >
          <a-select-option
            v-for="country in countries"
            :key="country.areaCode"
            :value="country.areaCode"
            :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
          >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.countryOfCustDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.countryOfCustMessage }}</span>
        </div>
      </a-form-item>

      <!-- 合作伙伴和供应商所在国家/地区 -->
      <a-form-item name="suppliersCountry" :label="$t('pages_merchant2_037')" :rules="{ required: true }">
        <div class="explain">{{ $t('pages_merchant2_037_0') }}</div>
        <a-select
          v-model:value="modelForm.suppliersCountry"
          class="input-primary"
          :placeholder="$t('pages_merchant2_037')"
          mode="multiple"
          allow-clear
          :max-tag-count="5"
          @change="handleSuppliersCountryChange"
        >
          <a-select-option
            v-for="country in countries"
            :key="country.areaCode"
            :value="country.areaCode"
            :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
          >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.suppliersCountryDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.suppliersCountryMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '3-2')"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed } from 'vue'
import i18n from '@/locale'
import { message } from 'ant-design-vue'

export default {
  name: 'OtherInfo',
  components: {
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    risked: {
      type: Boolean,
      default: () => { return false }
    },
    countries: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup (props, ctx) {
    const step14Ref = ref(null)

    const state = reactive({
      language: localStorage.getItem('locale-language') || 'zh'
    })

    const clientSourceOptions = [
      { value: '1', label: i18n.global.t('pages_merchant2_034-1') },
      { value: '2', label: i18n.global.t('pages_merchant2_034-2') },
      { value: '3', label: i18n.global.t('pages_merchant2_034-3') },
      { value: '4', label: i18n.global.t('pages_merchant2_034-4') },
      { value: '5', label: i18n.global.t('pages_merchant2_034-5') },
      { value: '6', label: i18n.global.t('pages_merchant2_034-6') }
    ]

    state.modelForm = computed(() => {
      return props.model
    })

    const submit = () => {
      ctx.emit('next', props.risked ? '3-6' : '3-4')
    }

    // nextTick(() => {
    //   const { docPath } = state.modelForm
    //   if (docPath.length !== 0 && uploadRef.value) uploadRef.value.fileListRefresh(docPath)
    // })

    const handleCountryChange = (selectedValues) => {
      if (selectedValues.length > 5) {
        message.warning(i18n.global.t('pages_merchant2_036_1')) // 请添加对应的国际化字段
        state.modelForm.countryOfCust = selectedValues.slice(0, 5)
      }
    }

    const handleSuppliersCountryChange = (selectedValues) => {
      if (selectedValues.length > 5) {
        message.warning(i18n.global.t('pages_merchant2_036_1'))
        state.modelForm.suppliersCountry = selectedValues.slice(0, 5)
      }
    }

    return {
      step14Ref,
      clientSourceOptions,
      submit,
      handleCountryChange,
      handleSuppliersCountryChange,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#otherInfo {
  .material-other-info-form {
    .explain {
      color: #495060;
    }
    .input-primary:deep(.ant-input) {
      border-radius: 5px;
    }
  }
}

</style>

